import React from 'react';
import { MessageCircle } from 'lucide-react';
import { Button } from './ui/button';
import { motion } from 'framer-motion';

export const FloatingWhatsApp = () => {
  const whatsappNumber = '+94704003030';
  const message = 'Hello! I would like to know more about VTV Enterprises.';
  const whatsappUrl = `https://wa.me/${whatsappNumber.replace(/[^0-9]/g, '')}?text=${encodeURIComponent(message)}`;

  return (
    <motion.div
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 1, type: 'spring', stiffness: 260, damping: 20 }}
      className="fixed bottom-24 right-6 z-40"
    >
      <Button
        asChild
        size="icon"
        className="h-14 w-14 rounded-full bg-[#25D366] hover:bg-[#20BA5A] shadow-lg hover:shadow-xl transition-all duration-300 animate-pulse-slow"
      >
        <a
          href={whatsappUrl}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Chat on WhatsApp"
        >
          <MessageCircle className="h-7 w-7 text-white" />
        </a>
      </Button>
    </motion.div>
  );
};
